export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/30705c7323e3-tooliconspeech.jpg',
  },
  title: 'Who have you reported the scam to?',
}
